import React from 'react';

function UsFlag() {
  return (
    <svg viewBox="0 0 19 10" className="h-3.5 w-6 overflow-hidden rounded-[3px] shadow-sm" aria-hidden="true">
      <rect width="19" height="10" fill="#bf0a30" />
      <g fill="#fff">
        <rect y="1.43" width="19" height="0.77" />
        <rect y="2.97" width="19" height="0.77" />
        <rect y="4.51" width="19" height="0.77" />
        <rect y="6.05" width="19" height="0.77" />
        <rect y="7.59" width="19" height="0.77" />
        <rect y="9.13" width="19" height="0.77" />
      </g>
      <rect width="8" height="5.4" fill="#002868" />
      <g fill="#fff">
        <circle cx="1.3" cy="1.1" r="0.28" />
        <circle cx="2.7" cy="1.1" r="0.28" />
        <circle cx="4.1" cy="1.1" r="0.28" />
        <circle cx="5.5" cy="1.1" r="0.28" />
        <circle cx="6.9" cy="1.1" r="0.28" />
        <circle cx="2" cy="2.15" r="0.28" />
        <circle cx="3.4" cy="2.15" r="0.28" />
        <circle cx="4.8" cy="2.15" r="0.28" />
        <circle cx="6.2" cy="2.15" r="0.28" />
        <circle cx="1.3" cy="3.2" r="0.28" />
        <circle cx="2.7" cy="3.2" r="0.28" />
        <circle cx="4.1" cy="3.2" r="0.28" />
        <circle cx="5.5" cy="3.2" r="0.28" />
        <circle cx="6.9" cy="3.2" r="0.28" />
        <circle cx="2" cy="4.25" r="0.28" />
        <circle cx="3.4" cy="4.25" r="0.28" />
        <circle cx="4.8" cy="4.25" r="0.28" />
        <circle cx="6.2" cy="4.25" r="0.28" />
      </g>
    </svg>
  );
}

function IlFlag() {
  return (
    <svg viewBox="0 0 22 16" className="h-3.5 w-6 overflow-hidden rounded-[3px] shadow-sm" aria-hidden="true">
      <rect width="22" height="16" fill="#fff" />
      <rect y="2" width="22" height="2.1" fill="#0038b8" />
      <rect y="11.9" width="22" height="2.1" fill="#0038b8" />
      <g fill="none" stroke="#0038b8" strokeWidth="0.7" strokeLinejoin="round">
        <polygon points="11,4.7 14.2,10.1 7.8,10.1" />
        <polygon points="11,11.3 14.2,5.9 7.8,5.9" />
      </g>
    </svg>
  );
}

const OPTIONS = [
  { id: 'en', label: 'English', flag: <UsFlag /> },
  { id: 'he', label: 'עברית', flag: <IlFlag /> },
];

export default function LanguageToggle({ value, onChange, disabled = false }) {
  const selected = value === 'he' ? 'he' : 'en';
  return (
    <div
      role="group"
      aria-label="Document language"
      className={`relative inline-flex h-9 items-center rounded-full bg-gray-100 p-0.5 ${disabled ? 'opacity-50' : ''}`}
    >
      <span
        aria-hidden="true"
        className={`absolute left-0.5 top-0.5 h-8 w-9 rounded-full bg-white shadow-sm transition-transform duration-200 ease-out ${
          selected === 'he' ? 'translate-x-9' : 'translate-x-0'
        }`}
      />
      {OPTIONS.map((option) => {
        const active = selected === option.id;
        return (
          <button
            key={option.id}
            type="button"
            aria-label={option.label}
            aria-pressed={active}
            title={option.label}
            disabled={disabled}
            onClick={() => {
              if (!active) onChange(option.id);
            }}
            className="relative z-10 inline-flex h-8 w-9 items-center justify-center rounded-full disabled:cursor-default"
          >
            {option.flag}
          </button>
        );
      })}
    </div>
  );
}
